<template>
    <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
        <div class="mt-6 flex items-center justify-between px-6">
            <h4>{{ (!data.id) ? $t("new") : $t("update_a") }} {{ $t("class") }}</h4>
            <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"/>
        </div>
        <vs-divider class="mb-0" />
        <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">
            <div class="px-6 py-2">
              <p >{{ $t("serie") }}</p>
              <v-select :options="series" :reduce="rep => rep.id" @search="getSerie" :clearable="true" label="code" v-model="input.serie" class="w-full"/>                
              <span v-if="error.serie || all_errors.serie.length" class="span-text-validation con-text-validation span-text-validation-danger vs-input--text-validation-span">
                <p v-for="(err, io) in all_errors.serie" :key="io" style="margin-bottom: 4px !important; font-size: 13px">{{err}}</p>
              </span>

              <p class="mt-5">{{ $t("level") }} <b style="color: #ff6141">*</b> </p>
              <v-select :options="niveaus" :reduce="rep => rep.id" @search="getNiveau" :clearable="true" label="libelle" v-model="input.niveau" class="w-full"/>                
              <span v-if="error.niveau || all_errors.niveau.length" class="span-text-validation con-text-validation span-text-validation-danger vs-input--text-validation-span">
                <p v-for="(err, io) in all_errors.niveau" :key="io" style="margin-bottom: 4px !important; font-size: 13px">{{err}}</p>
              </span>

              <p class="mt-5" >{{ $t("code") }} <b style="color: #ff6141">*</b> </p>
              <vs-input
                @keyup.enter="submitData"
                :disabled="detail__detail"
                :danger="error.code || all_errors.code.length ? true : false"
                v-model="input.code" class="w-full"/>
              <span v-if="error.code || all_errors.code.length" class="span-text-validation con-text-validation span-text-validation-danger vs-input--text-validation-span">
                <p v-for="(err, io) in all_errors.code" :key="io" style="margin-bottom: 4px !important; font-size: 13px">{{err}}</p>
              </span>

              <p class="mt-5" >{{ $t("name") }} <b style="color: #ff6141">*</b> </p>
              <vs-input
                @keyup.enter="submitData"
                :disabled="detail__detail"
                :danger="error.libelle || all_errors.libelle.length ? true : false"
                v-model="input.libelle" class="w-full"/>
              <span v-if="error.libelle || all_errors.libelle.length" class="span-text-validation con-text-validation span-text-validation-danger vs-input--text-validation-span">
                <p v-for="(err, io) in all_errors.libelle" :key="io" style="margin-bottom: 4px !important; font-size: 13px">{{err}}</p>
              </span>

              <div v-if="input.code">
                <p class="mt-5" >{{ $t("number_of_room") }} <b style="color: #ff6141">*</b> </p>
                <vs-input-number class="ml-0" v-model="input.number_of_room" />
                <span v-if="error.number_of_room || all_errors.number_of_room.length" class="span-text-validation con-text-validation span-text-validation-danger vs-input--text-validation-span">
                  <p v-for="(err, io) in all_errors.number_of_room" :key="io" style="margin-bottom: 4px !important; font-size: 13px">{{err}}</p>
                </span>
              </div>

              <div v-if="input.salles.length || input.salles_second.length">
                <vs-list-header icon-pack="feather" icon="icon-layers" :title="$t('room')" color="success"></vs-list-header>
                <vs-list-item v-for="(item, io) in input.salles_second" :key="io" icon-pack="feather" icon="icon-shield" :title="item.libelle" :subtitle="$t('room_capacity')">
                  <vs-input-number color="success" class="ml-0" v-model="item.capacite"/>
                </vs-list-item>
                <vs-list-item v-for="(item, io) in input.salles" :key="old_capacity + io" icon-pack="feather" icon="icon-shield" :title="item.libelle" :subtitle="$t('room_capacity')">
                  <vs-input-number color="success" class="ml-0" v-model="item.capacite"/>
                </vs-list-item>
              </div>
            </div>
        </VuePerfectScrollbar>
        
        <div v-if="!detail__detail" class="flex flex-wrap items-center p-6" slot="footer">
            <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">{{ $t("Submit") }}</vs-button>
            <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">{{ $t("Cancel") }}</vs-button>
        </div>
    </vs-sidebar>
</template>

<script>
const libelle_default = 'Classe de '
let base_self = ''
const input_tempon = {
  id: null,
  libelle: '',
  code: '',
  is_active: true,
  number_of_room: '',
  salles: [],
  salles_second: [],
  niveau: '',
  serie: ''
}

const alphabet_list = {}
alphabet_list[1] = 'A'
alphabet_list[2] = 'B'
alphabet_list[3] = 'C'
alphabet_list[4] = 'D'
alphabet_list[5] = 'E'
alphabet_list[6] = 'F'
alphabet_list[7] = 'G'
alphabet_list[8] = 'H'
alphabet_list[9] = 'I'
alphabet_list[10] = 'J'
alphabet_list[11] = 'K'
alphabet_list[12] = 'L'
alphabet_list[13] = 'M'
alphabet_list[14] = 'N'
alphabet_list[15] = 'O'
alphabet_list[16] = 'P'
alphabet_list[17] = 'Q'
alphabet_list[18] = 'R'
alphabet_list[19] = 'S'
alphabet_list[20] = 'T'
alphabet_list[21] = 'U'
alphabet_list[22] = 'V'
alphabet_list[23] = 'W'
alphabet_list[24] = 'X'
alphabet_list[25] = 'Y'
alphabet_list[26] = 'Z'

const initialNoError_tempon = {}
const error_tempon = {}
const all_errors_tempon = {}

const keys = Object.keys(input_tempon)
const length = keys.length
for (let i = 0; i < length; i++) {
  initialNoError_tempon[keys[i]] = false
  error_tempon[keys[i]] = false
  all_errors_tempon[keys[i]] = []
}

import VuePerfectScrollbar from 'vue-perfect-scrollbar'
export default {
  components: {VuePerfectScrollbar},
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      old_capacity: 0,
      niveaus: [],
      series: [],
      initialNoError: JSON.parse(JSON.stringify(initialNoError_tempon)),
      error: JSON.parse(JSON.stringify(error_tempon)),
      all_errors: JSON.parse(JSON.stringify(all_errors_tempon)),
      input: JSON.parse(JSON.stringify(input_tempon)),
      input1: JSON.parse(JSON.stringify(input_tempon)),
      detail__detail: false,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
        }
      }
    },
    isFormValid () {
      let is_valide = true
      if (!base_self.input.libelle || base_self.input.libelle === '') is_valide = false
      if (!base_self.input.number_of_room || base_self.input.number_of_room === '') is_valide = false
      if (!base_self.input.code || base_self.input.code === '') is_valide = false
      if (!base_self.input.niveau || base_self.input.niveau === '') is_valide = false

      const length = base_self.input.salles.length
      for (let i = 0; i < length; i++) {
        if (!base_self.input.salles[i].capacite || base_self.input.salles[i].capacite === '') {
          is_valide = false
          break
        }
      }

      return is_valide
    }
  },
  methods: { 
    countRoom (data) {
      const param = {
        is_get: true,
        filter: {
          classe: data.id
        },
        orderby: ['ordre'],
        exclude: { code: 'Attente' }
      }

      base_self.$http.post(`${base_self.$store.state.route_for_esm}Salle`, param)
        .then((response) => {
          base_self.old_capacity = response.data.taille
          data.number_of_room = response.data.taille
          data.salles_second = response.data.data
          data.salles = []

          base_self.input1 = JSON.parse(JSON.stringify(data))
          base_self.input = JSON.parse(JSON.stringify(data))
        })
        .catch(() => {
          window.getESM.error(base_self.$t('The_server_is_not_responding'))
        })
    },
    getSerieSimple () {
      const data = {
        is_get: true,
        paginate: {
          length: 50,
          page: 1
        },
        filter: { }
      }
      base_self.$http.post(`${base_self.$store.state.route_for_esm}Serie`, data)
        .then((response) => {
          base_self.series = response.data.data
        })
        .catch((error) => { 
          console.log('error: ', error)
        })
    },   
    getSerie (search, loading) {
      loading(true)
      const data = {
        is_get: true,
        paginate: {
          length: 50,
          page: 1
        },
        filter: { libelle__icontains: search }
      }
      base_self.$http.post(`${base_self.$store.state.route_for_esm}Serie`, data)
        .then((response) => {
          base_self.series = response.data.data
          loading(false)
        })
        .catch((error) => { 
          loading(false)
          console.log('error: ', error)
        })
    },
    getNiveauSimple () {
      const data = {
        is_get: true,
        paginate: {
          length: 50,
          page: 1
        },
        filter: { is_active: true }
      }
      base_self.$http.post(`${base_self.$store.state.route_for_esm}Niveau`, data)
        .then((response) => {
          base_self.niveaus = response.data.data
        })
        .catch((error) => { 
          console.log('error: ', error)
        })
    },   
    getNiveau (search, loading) {
      loading(true)
      const data = {
        is_get: true,
        paginate: {
          length: 50,
          page: 1
        },
        filter: { is_active: true, libelle__icontains: search }
      }
      base_self.$http.post(`${base_self.$store.state.route_for_esm}Niveau`, data)
        .then((response) => {
          base_self.niveaus = response.data.data
          loading(false)
        })
        .catch((error) => { 
          loading(false)
          console.log('error: ', error)
        })
    },
    verification_niveau  () {
      const niveau = base_self.$t('The_level_is_required')
      if (!base_self.initialNoError.niveau) return false
      if (base_self.input.niveau.length === 0) {
        base_self.all_errors.niveau.push(niveau)
      } else {
        base_self.all_errors.niveau = base_self.all_errors.niveau.filter(e => e !== niveau)
      }
    },
    verification_number_of_room  () {
      const number_of_room = base_self.$t('The_number_of_room_is_required')
      if (!base_self.initialNoError.number_of_room) return false
      if (base_self.input.number_of_room.length === 0) {
        base_self.all_errors.number_of_room.push(number_of_room)
      } else {
        base_self.all_errors.number_of_room = base_self.all_errors.number_of_room.filter(e => e !== number_of_room)
      }
    },
    verification_libelle  () {
      const libelle = base_self.$t('The_name_is_required')
      if (!base_self.initialNoError.libelle) return false
      if (base_self.input.libelle.length === 0) {
        base_self.all_errors.libelle.push(libelle)
      } else {
        base_self.all_errors.libelle = base_self.all_errors.libelle.filter(e => e !== libelle)
      }
    },
    verification_code  () {
      const code = base_self.$t('The_code_is_required')
      if (!base_self.initialNoError.code) return false
      if (base_self.input.code.length === 0) {
        base_self.all_errors.code.push(code)
      } else {
        base_self.all_errors.code = base_self.all_errors.code.filter(e => e !== code)
      }
    },
    createRoom (i, nbre) {
      base_self.input.salles = []
      for (; i < nbre; i++) {
        base_self.input.salles.push({
          is_active: true,
          libelle: `Salle ${alphabet_list[i]} des ${base_self.input.code}`,
          code: alphabet_list[i],
          capacite: ''
        })
      }
    },
    async submitData () {
      if (!base_self.isFormValid) {
        window.getESM.error(base_self.$t('The_form_is_invalid'))
        return
      }
      base_self.$vs.loading()
      
      const input = JSON.parse(JSON.stringify(this.input))
      
      const salles_second = []
      const length = input.salles_second.length
      for (let i = 0; i < length; i++) {
        salles_second.push({
          id: input.salles_second[i].id,
          capacite: input.salles_second[i].capacite
        })
      }
      input.salles.push(...salles_second)
      delete input.salles_second
      
      if (!input.id) {   
        input.salles.unshift({
          is_active: true,
          libelle: `Salle d'attente des ${base_self.input.code}`,
          code: 'Attente',
          capacite: 10000
        })

        base_self.$http.post(`${base_self.$store.state.route_for_esm}Classe`, input)
          .then((response) => { 
            window.getESM.success(base_self.$t('The_class_is_added_successfully'), response)
            base_self.$vs.loading.close()
            this.$emit('closeSidebar')
            this.initValues()
          })
          .catch((error) => { 
            console.log('error: ', error)
            base_self.$vs.loading.close()
          })

      } else if (input.id) {
        base_self.$http.put(`${base_self.$store.state.route_for_esm}Classe`, input)
          .then((response) => { 
            window.getESM.success(base_self.$t('The_class_is_changed_successfully'), response)
            base_self.$vs.loading.close()
            this.$emit('closeSidebar')
            this.initValues()
          })
          .catch((error) => { 
            console.log('error: ', error)
            base_self.$vs.loading.close()
          })
      }
    },
    initValues () {
      base_self.initialNoError = JSON.parse(JSON.stringify(initialNoError_tempon))
      base_self.input = JSON.parse(JSON.stringify(input_tempon))
      base_self.input1 = JSON.parse(JSON.stringify(input_tempon))
      base_self.detail__detail = false
    }
  },
  watch: {
    input: {
      handler  () {
        if (base_self.input1.niveau !== base_self.input.niveau) {
          base_self.initialNoError.niveau = true
          base_self.verification_niveau()
        }

        if (base_self.input1.number_of_room !== base_self.input.number_of_room) {
          if (base_self.input.number_of_room > 26) {
            base_self.input.number_of_room = 26
          }
          if (base_self.input.id !== null && base_self.old_capacity > base_self.input.number_of_room) {
            base_self.input.number_of_room = base_self.old_capacity
          }
          base_self.initialNoError.number_of_room = true
          base_self.verification_number_of_room()

          let i = 1
          if (base_self.input.id !== null) {
            i = base_self.old_capacity + 1
          }

          base_self.createRoom(i, Number(base_self.input.number_of_room) + 1)
        }

        if (base_self.input1.libelle !== base_self.input.libelle) {
          base_self.initialNoError.libelle = true
          base_self.verification_libelle()
        }

        if (base_self.input1.code !== base_self.input.code) {
          base_self.initialNoError.code = true
          
          base_self.input.libelle = libelle_default + base_self.input.code
          base_self.verification_code()
        }

        base_self.input1 = JSON.parse(JSON.stringify(base_self.input))
      },
      deep: true
    },
    async isSidebarActive () {
      base_self.getSerieSimple()
      base_self.getNiveauSimple()
      this.initValues()
      if (base_self.data && base_self.data.id) {
        base_self.countRoom(base_self.data)
      } else if (base_self.data.niveau) {
        base_self.input.niveau = base_self.data.niveau
      }
    }
  },
  created () {
    base_self = this
    base_self.initValues()
  }
}
</script>

<style lang="scss" scoped>
  .add-new-data-sidebar {
      ::v-deep .vs-sidebar--background {
          z-index: 52010;
      }

      ::v-deep .vs-sidebar {
          z-index: 52010;
          width: 400px;
          max-width: 90vw;

          .img-upload {
              margin-top: 2rem;

              .con-img-upload {
                  padding: 0;
              }

              .con-input-upload {
                  width: 100%;
                  margin: 0;
              }
          }
      }
  }

  .scroll-area--data-list-add-new {
      // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
      height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
      
  }
</style>

<style>
[dir] .vs__dropdown-toggle {
  border-radius: 20px;
}

[dir] .vdp-datepicker input {
  border-radius: 20px;
}
</style>
